import { LOAD_ROLES, LOAD_ROLES_SUCCESS, TRANSFORM_ROLES, SELECT_GROUP } from "./types";
import axios from '../../lib/axios';
import config from '../../config/app-config.json';


export const loadRoles = (history = null, redirect = false) => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_ROLES,
            payload: []
        })
        axios.get(`${config.serviceUrl}/roles`).then((response) => {
            dispatch({
                type: LOAD_ROLES_SUCCESS,
                payload: response.data.Groups
            })

            dispatch({
                type: TRANSFORM_ROLES,
                payload: response.data.Groups
            })
        })
    }
}

export const loadExternalRoles = (history = null, redirect = false) => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_ROLES,
            payload: []
        })
        axios.get(`${config.serviceUrl}/external-roles`).then((response) => {
            dispatch({
                type: LOAD_ROLES_SUCCESS,
                payload: response.data.Groups
            })

            dispatch({
                type: TRANSFORM_ROLES,
                payload: response.data.Groups
            })
        })
    }
}


export const selectGroup = (group, name) => {
    return {
        type: SELECT_GROUP,
        payload: {groups: group, name: name}
    }
}